export const backgroundInlineStyles = (backgroundSrc?: string, staticAssetsBaseURL?: string | null) => {
  if (!backgroundSrc) return {};

  let resolvedSrc = backgroundSrc;

  // Prepend staticAssetsBaseURL if available and src is relative
  if (staticAssetsBaseURL && !backgroundSrc.startsWith('http')) {
    resolvedSrc = `https://${staticAssetsBaseURL}${backgroundSrc}`;
  }

  return {
    backgroundImage: `url(${resolvedSrc})`,
    backgroundRepeat: 'no-repeat',
  };
};
